import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Backdrop, Fade, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Button from '../../buttons/Button';
import { mergeClassNames } from '../../../utils';

import styles from './ConfirmationModal.css';

type Props = {
  title?: string;
  message: string;
  buttonTitle?: string;
  onModalClose?: () => void;
  handleSubmit: () => void;
};

const ConfirmationModal: FC<Props> = ({ title, message, buttonTitle, onModalClose, handleSubmit }) => {
  const { t } = useTranslation();
  const translationRoot = 'MOBILE_PRINTER';

  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    // Prevent closing on backdrop click or escape key press
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    if (onModalClose) {
      onModalClose();
    }
  };

  return (
    <Modal
      open
      onClose={handleClose}
      className={styles.modalRoot}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 300 }}
      aria-labelledby="pick-tour-title"
      aria-describedby="pick-tour-description"
    >
      <Fade in>
        <div className={styles.modalPaper} role="dialog" aria-modal="true">
          {title && (
            <div className={styles.modalHeader}>
              <h2 className={styles.modalHeading}>{title}</h2>
              {
                onModalClose && (
                    <IconButton onClick={onModalClose} className={styles.closeButton} aria-label="Close modal">
                      <CloseIcon />
                    </IconButton>
                )
              }
            </div>
          )}
          <div
            className={mergeClassNames(title ? '' : styles.modalContentBold, styles.modalContent)}
            id="pick-tour-description"
          >
            <p>{message}</p>
          </div>
          <div className={mergeClassNames(onModalClose ? '' : styles.buttonCenter, styles.modalFooter)}>
            {onModalClose && (
              <Button
                className={styles.button}
                data-cy="cancel-button"
                aria-label={t(`${translationRoot}.CANCEL`)}
                onClick={onModalClose}
              >
                {t(`${translationRoot}.CANCEL`)}
              </Button>
            )}
            <Button
              className={mergeClassNames(styles.button, styles.submitButton)}
              data-cy="submit-button"
              aria-label={t(`${translationRoot}.SUBMIT`)}
              onClick={handleSubmit}
            >
              {buttonTitle || t(`${translationRoot}.SUBMIT`)}
            </Button>
          </div>
        </div>
      </Fade>
    </Modal>
  );
};

export default ConfirmationModal;
